<template>
  <div class="asc-error-type-icon-label--container">
    <asc-error-type-icon
      class="asc-error-type-label--icon"
      :error-type="errorType"
    ></asc-error-type-icon>
    <asc-error-type-label
      class="asc-error-type-label--title"
      :value="errorType"
    ></asc-error-type-label>
  </div>
</template>

<script>
import AscErrorTypeIcon from './AscErrorTypeIcon'
import AscErrorTypeLabel from './AscErrorTypeLabel'

export default {
  name: 'AscErrorTypeIconLabel',

  components: {
    AscErrorTypeIcon,
    AscErrorTypeLabel,
  },

  props: {
    errorType: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-error-type-icon-label--container {
  display: flex;
  margin-top: -2px;

  & .asc-error-type-label--title {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
  }
}
</style>
